import {
  PulseFilters,
  PulsePaginatedFilters,
  pulseFiltersSchema,
  pulsePaginatedFiltersSchema,
} from './types'

import { api } from 'api'
import { z } from 'zod'

const payRateByPositionResponse = z.array(
  z.object({
    pay_rate: z.string(),
    fill_rate: z.number(),
    filled_shifts: z.number(),
    position_type: z.string(),
    location_count: z.number(),
    repeat_worker_rate: z.number().nullable().optional(),
    reliability_rate: z.number().nullable().optional(),
    avg_worker_to_manager_rating: z.number().nullable().optional(),
    avg_market_pay_rate: z.number().nullable().optional(),
  })
)

export type PayRateByPosition = z.infer<typeof payRateByPositionResponse>

export async function getPayRateByPosition(
  filters: PulsePaginatedFilters,
  signal?: AbortSignal
) {
  const data = pulsePaginatedFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/pay_rate_by_position', data, { signal })
    .then((response) => response.data)
    .then(payRateByPositionResponse.parse)
}

export async function getPayRateByPositionCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)

  return await api
    .post('/company/pulse/operations/pay_rate_by_position/csv', data, {
      signal,
    })
    .then((response) => response.data)
}
